import script from "./ProyectosBackend.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProyectosBackend.vue?vue&type=script&setup=true&lang=ts"

import "./ProyectosBackend.vue?vue&type=style&index=0&id=6ab19fcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ab19fcc"]])

export default __exports__